import type { ListingSortOption } from './listingToolbarConfig';

export function buildListingSortConfig(
  sortBy: string,
  setSortBy: (value: string) => void,
  options: ListingSortOption[],
) {
  return {
    value: sortBy,
    onChange: setSortBy,
    options,
  };
}
